/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Clock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Clock"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M11.167 6.167a.833.833 0 1 1 1.666 0v5.416l3 2.25a.833.833 0 0 1-1 1.334l-3.333-2.5a.83.83 0 0 1-.333-.667z"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.667 0a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const ClockIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'clock-icon'}
      icon={Clock}
      {...props}
      size={size}
    />
  );
};
